import { Pipe, PipeTransform } from '@angular/core';
import { ContentContextType } from '@shared/enums/ContentContextType';
import { ContentMediaType } from '@shared/enums/ContentMediaType';
import { IContentModel } from '@shared/models/content.model';

@Pipe({
    name: 'filterContentFile'
})
export class FilterContentFilePipe implements PipeTransform {
    transform(contents: IContentModel[], language: string, contextType?: ContentContextType, mediaType?: ContentMediaType): any {
        let value = null;

        if (contextType && mediaType) {
            value = contents?.find(x => x.languageId === language && x.contentContextType === contextType && x.contentMediaType === mediaType)?.file;
        } else if (contextType) {
            value = contents?.find(x => x.languageId === language && x.contentContextType === contextType)?.file;
        } else {
            value = contents?.find(x => x.languageId === language)?.file;
        }

        return value;
    }
}
